package com.havn.app.ui.theme

import androidx.compose.runtime.staticCompositionLocalOf

val LocalHavnThemeTokens = staticCompositionLocalOf {
    HavnThemeCatalog.ObsidianGold
}
